"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagMapState = exports.ZOOM_SWITCH_JOBS_LEVEL = exports.ZOOM_SWITCH_LEVEL = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const modal_service_1 = require("../../components/modal/modal.service");
const dom_1 = require("../../dom");
const i18n_1 = require("../../i18n");
const services_1 = require("../../services");
const mobx_2 = require("../../state/mobx");
const page_state_1 = require("../../state/page.state");
const store_1 = require("../../store");
const projection_cache_1 = require("../google/projection.cache");
const bounding_string_1 = require("./bounding.string");
const BOUNDS_EXTEND_DELTA = 0.0005;
const BOUNDS_MIN_DISTANCE_METERS = 100;
const ZOOM_DETAIL_SWITCH_LEVEL = 19;
exports.ZOOM_SWITCH_LEVEL = 15;
exports.ZOOM_SWITCH_JOBS_LEVEL = 12;
class TagMapState extends mobx_2.MobxState {
    constructor(tagState) {
        super();
        this.boundString = mobx_1.observable.box('', { name: 'BoundsString' });
        this.tagState = tagState;
        this.initMapLocation();
    }
    initMapLocation() {
        const locationString = services_1.Services.Route.params.get('location');
        const parsedBounds = bounding_string_1.BoundingString.fromString(locationString);
        if (parsedBounds == null) {
            return;
        }
        const actualBounds = new google.maps.LatLngBounds();
        actualBounds.extend(parsedBounds);
        this.bounds = actualBounds;
        this.zoom = parsedBounds.zoom;
    }
    setMap(map) {
        this.map = map;
    }
    get visibleTags() {
        this.boundString.get();
        const tags = [];
        for (const tag of this.tagState.filteredTags) {
            const tagSummary = store_1.AppStore.TagSummary.get(tag.objectId);
            if (tagSummary == null || tagSummary.center == null) {
                continue;
            }
            if (this.bounds == null || this.bounds.contains(tagSummary.center)) {
                tags.push(tag.objectId);
            }
        }
        return tags;
    }
    get visibleCollections() {
        this.boundString.get();
        // trace();
        if (this.bounds == null) {
            return [];
        }
        const visibleCollections = [];
        const selectedTagId = page_state_1.CurrentState.inspectedTagId;
        const inspectedCollectionRevision = page_state_1.CurrentState.inspectedCollectionRevision;
        let inspectedCollection = null;
        for (const tag of this.tagState.filteredTags) {
            const tagSummary = store_1.AppStore.TagSummary.get(tag.objectId);
            if (tagSummary == null || tagSummary.center == null || tagSummary.bounds == null) {
                continue;
            }
            const isTagSelected = selectedTagId === tag.objectId;
            const ne = tagSummary.bounds.ne;
            const sw = tagSummary.bounds.sw;
            const isTagInBounds = this.bounds.intersects({
                north: ne.lat,
                east: ne.lng,
                south: sw.lat,
                west: sw.lng
            });
            if (isTagInBounds === true) {
                for (const revision of tagSummary.revisions) {
                    const summary = store_1.AppStore.CollectionSummary.get(revision);
                    if (summary == null || summary.location == null) {
                        continue;
                    }
                    // Render the inspected collection last
                    if (inspectedCollectionRevision === summary.revision) {
                        inspectedCollection = summary.revision;
                    }
                    else if (isTagSelected) {
                        visibleCollections.push(summary.revision);
                    }
                    else if (this.bounds.contains(this.getLatLng(summary.location))) {
                        visibleCollections.push(summary.revision);
                    }
                }
            }
        }
        if (inspectedCollection != null) {
            visibleCollections.push(inspectedCollection);
        }
        return visibleCollections;
    }
    centerMap() {
        const visibleBounds = new google.maps.LatLngBounds();
        const summaries = [];
        for (const tag of this.tagState.filteredTags) {
            const tagSummary = store_1.AppStore.TagSummary.get(tag.objectId);
            if (tagSummary != null) {
                summaries.push(tagSummary);
            }
        }
        if (summaries.length > 0) {
            for (const summary of summaries) {
                if (summary.bounds != null) {
                    visibleBounds.extend(summary.bounds.ne).extend(summary.bounds.sw);
                }
            }
        }
        else {
            visibleBounds.extend({ lat: 80, lng: 180 });
            visibleBounds.extend({ lat: -80, lng: -180 });
        }
        this.map.fitBounds(visibleBounds);
        this.map.setCenter(visibleBounds.getCenter());
    }
    setBounds(bounds) {
        const newBounds = bounds.toUrlValue();
        if (newBounds === this.boundString.get()) {
            return;
        }
        this.bounds = bounds;
        this.boundString.set(bounds.toUrlValue());
    }
    setZoom(zoom) {
        if (zoom === this.zoom) {
            return;
        }
        if (zoom !== this.zoom) {
            projection_cache_1.PointCache.reset();
        }
        this.zoom = zoom;
    }
    zoomToId(type, id) {
        if (type === dom_1.DragonDomTypes.TAG) {
            return this.zoomToTag(id);
        }
    }
    zoomToTag(tagId) {
        const tag = this.tagState.filteredTags.find(t => t.objectId === tagId);
        if (tag == null) {
            return null;
        }
        const tagSummary = store_1.AppStore.TagSummary.get(tag.objectId);
        if (tagSummary == null || tagSummary.bounds == null) {
            return null;
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Tag', tag.objectId, 1);
        let bounds = new google.maps.LatLngBounds(tagSummary.bounds.sw, tagSummary.bounds.ne);
        bounds = this.ensureAppropriateBounds(bounds);
        this.map.fitBounds(bounds);
    }
    get showDetail() {
        return this.zoom >= ZOOM_DETAIL_SWITCH_LEVEL;
    }
    inspectHovered() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const revision = page_state_1.CurrentState.hoverId;
            const collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
            if (collectionSummary == null) {
                return;
            }
            // Mark the collection to link to
            if (page_state_1.CurrentState.CollectionLink.isLinking) {
                page_state_1.CurrentState.CollectionLink.completeLinking(collectionSummary);
                return;
            }
            // Inspect the collection
            const canChange = yield this.checkChangeCollection(collectionSummary.revision);
            if (canChange) {
                page_state_1.CurrentState.setInspectedCollection(collectionSummary.revision);
            }
        });
    }
    zoomToCollection(revision) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (revision === page_state_1.CurrentState.inspectedCollectionRevision) {
                this.handleZoomToCollection(revision);
                return;
            }
            const canChange = yield this.checkChangeCollection(revision);
            if (!canChange) {
                return;
            }
            let newRevision = revision;
            const latestSummary = store_1.AppStore.CollectionSummary.getLatest(revision);
            if (latestSummary != null) {
                newRevision = latestSummary.revision;
            }
            page_state_1.CurrentState.setInspectedCollection(newRevision);
            this.handleZoomToCollection(newRevision);
        });
    }
    handleZoomToCollection(revision) {
        const collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
        if (collectionSummary == null || collectionSummary.location == null) {
            return;
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Collection', collectionSummary.uuid, 1);
        let bounds = this.getLatLngBounds(collectionSummary.location);
        bounds = this.ensureAppropriateBounds(bounds);
        if (this.map != null) {
            this.map.fitBounds(bounds);
        }
    }
    checkChangeCollection(revision) {
        if (page_state_1.CurrentState.inspectedCollectionRevision == null) {
            return Promise.resolve(true);
        }
        if (page_state_1.CurrentState.inspectedCollectionRevision === revision) {
            return Promise.resolve(false);
        }
        return this.checkAndDiscardChanges();
    }
    checkAndDiscardChanges() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!page_state_1.CurrentState.CollectionEdit.isDirty) {
                page_state_1.CurrentState.CollectionEdit.reset();
                return true;
            }
            const response = yield modal_service_1.ModalService.open({
                title: i18n_1.T.DISCARD_CHANGES_TITLE,
                content: (0, i18n_1.Translate)(i18n_1.T.DISCARD_CHANGES_CONFIRM),
                okName: i18n_1.T.DISCARD_CHANGES_DISCARD,
                hasCancel: true
            });
            const summary = store_1.AppStore.CollectionSummary.get(page_state_1.CurrentState.inspectedCollectionRevision);
            if (summary != null) {
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'Collection:discard', summary.uuid, 1);
            }
            if (response.ok) {
                page_state_1.CurrentState.CollectionEdit.reset();
            }
            return response.ok;
        });
    }
    ensureAppropriateBounds(bounds) {
        const distance = google.maps.geometry.spherical.computeDistanceBetween(bounds.getNorthEast(), bounds.getSouthWest());
        if (distance < BOUNDS_MIN_DISTANCE_METERS) {
            const extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + BOUNDS_EXTEND_DELTA, bounds.getNorthEast().lng() + BOUNDS_EXTEND_DELTA);
            const extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - BOUNDS_EXTEND_DELTA, bounds.getNorthEast().lng() - BOUNDS_EXTEND_DELTA);
            bounds.extend(extendPoint1);
            bounds.extend(extendPoint2);
        }
        return bounds;
    }
    getLatLng(loc) {
        return new google.maps.LatLng(loc.coordinates[1], loc.coordinates[0]);
    }
    getLatLngBounds(loc) {
        return new google.maps.LatLngBounds({
            lat: loc.coordinates[1],
            lng: loc.coordinates[0]
        });
    }
}
exports.TagMapState = TagMapState;
tslib_1.__decorate([
    mobx_1.observable
], TagMapState.prototype, "zoom", void 0);
tslib_1.__decorate([
    mobx_1.action
], TagMapState.prototype, "setMap", null);
tslib_1.__decorate([
    mobx_1.computed.struct
], TagMapState.prototype, "visibleTags", null);
tslib_1.__decorate([
    mobx_1.computed.struct
], TagMapState.prototype, "visibleCollections", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TagMapState.prototype, "centerMap", null);
tslib_1.__decorate([
    mobx_1.action
], TagMapState.prototype, "setBounds", null);
tslib_1.__decorate([
    mobx_1.action
], TagMapState.prototype, "setZoom", null);
tslib_1.__decorate([
    mobx_1.action
], TagMapState.prototype, "zoomToId", null);
tslib_1.__decorate([
    mobx_1.action
], TagMapState.prototype, "zoomToTag", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TagMapState.prototype, "inspectHovered", null);
tslib_1.__decorate([
    mobx_1.action
], TagMapState.prototype, "handleZoomToCollection", null);
//# sourceMappingURL=tag.map.state.js.map